import React from 'react';
import { Button } from '@xo-union/tk-component-buttons';
import styles from '../index.scss';
import variantStyles from '../BasicInfoForm/index.scss';
import Loader from '../../../Loader';

interface Props {
  // onClick: () => void; //this has been removed because type submit is used in the Button component and this is on a form
  loading?: boolean;
  buttonText?: string;
  variant?: boolean;
}

const Continue: React.FC<Props> = ({ loading = false, buttonText = 'Continue', variant = false }) => (
  <div className={variant === true ? variantStyles.buttonContainer : styles.buttonContainer}>
    {loading ? (
      <Loader />
    ) : (
      <Button type="submit" data-testid="continue">
        {buttonText}
      </Button>
    )}
  </div>
);

export default Continue;
